import { trackDuration, wireInsertions } from "./trackContract.js"
import { buildChapterCues, buildThumbnailCues } from "./tracks.js"
import { buildVtt, parseVTT, shiftCues, subtitleVtt } from "./vtt.js"

/**
 * Overlays of one track. Its chapters/CTAs are already on its own playback timeline; the
 * transcript arrives on the original timeline and is shifted by the track's DC insertions
 * (none for a video track).
 */
export function chapterCuesFor(track) {
    if (!track) {
        return []
    }

    return buildChapterCues(
        track.chapters.map((chapter) => ({ id: chapter.id, title: chapter.title, from_time: chapter.start, image: chapter.image ?? null })),
        trackDuration(track),
    )
}

export function thumbnailCuesFor(chapterCues, fallbackImage, sizes = new Map()) {
    return buildThumbnailCues(chapterCues, fallbackImage, sizes)
}

export function transcriptCuesFor(text, track) {
    return shiftCues(parseVTT(text), wireInsertions(track))
}

export function trackSpecsFor({ track, chapterCues, thumbnailCues = [], transcripts = [], chaptersLabel, locale }) {
    const specs = []

    if (chapterCues.length > 0) {
        specs.push({ key: "chapters", kind: "chapters", label: chaptersLabel, srclang: locale, default: true, mode: "hidden", vtt: buildVtt(chapterCues) })
    }

    if (thumbnailCues.length > 0) {
        specs.push({ key: "thumbnails", kind: "metadata", label: "thumbnails", default: true, mode: "hidden", vtt: buildVtt(thumbnailCues, { escape: false }) })
    }

    const insertions = wireInsertions(track)

    for (const transcript of transcripts) {
        specs.push({ key: `subtitles:${transcript.lang}`, kind: "subtitles", label: transcript.label, srclang: transcript.lang, vtt: subtitleVtt(transcript.text, insertions) })
    }

    return specs
}
